import { useEffect } from 'react';
import { useStore } from '../../store';
import { maxOpenWindowsFor } from '../../store/slices/chatWindows';

const DEBOUNCE_MS = 150;

/**
 * Keeps `chatWindows.maxOpen` in step with the viewport: on mount, and 150 ms
 * after the last resize. `setChatMaxOpen` ignores an unchanged value, so a
 * drag-resize does not re-render the tray on every tick.
 */
export function useMaxOpenWindows(): void {
  const setChatMaxOpen = useStore(state => state.setChatMaxOpen);
  useEffect(() => {
    const apply = () => setChatMaxOpen(maxOpenWindowsFor(window.innerWidth));
    apply();
    let timer: ReturnType<typeof setTimeout> | undefined;
    const onResize = () => {
      clearTimeout(timer);
      timer = setTimeout(apply, DEBOUNCE_MS);
    };
    window.addEventListener('resize', onResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', onResize);
    };
  }, [setChatMaxOpen]);
}
